// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"ba638c8e","687":"263ebeeb","800":"263ebeeb","827":"ba638c8e","925":"263ebeeb"}[chunkId] + ".chunk.css";
};